import { Column, Control, Field, Select } from "@allxsmith/bestax-bulma";
import React, { useState } from "react";

function useInput({ label, initialValue, options, testId, callback, disabled }) {
  const [value, setValue] = useState(initialValue || "");

  const onChange = e => {
    setValue(e.target.value);
    if (callback) {
      callback(e);
    }
  };

  const input = (
    <Column>
      <Field>
        <label className="label">{label}</label>
        <Control>
          <Select value={value} onChange={onChange} data-testid={testId} disabled={disabled}>
            {options.map(item => (
              <option key={item.name} value={item.value}>
                {item.name}
              </option>
            ))}
          </Select>
        </Control>
      </Field>
    </Column>
  );
  return [value, input, setValue];
}

export default useInput;
